<button mat-stroked-button disableRipple class="filter-dialog-button" (click)="onClick()">
  <mat-icon class="filter__icon">tune</mat-icon>
  @if (markActiveFilters) {
  <em class="active-filters-marker"></em>
  } @if (screen !== 'phone') { Filter }
</button>
